import { firebase } from './api/firebase'
import { firebaseAction } from 'vuexfire'

const db = firebase.database()

const environment = require('../environments/production')

export const editor = {
  namespaced: true,
  state: {
    templateLibrary: {},
    userTemplates: {},
    activeTemplate: {},
    activeObject: 'styleText',
    availableFonts: {},
    activeFont: 'Arial',
    isTainted: false
  },
  getters: {
    canSaveToLibrary: (state, getters, rootState) => {
      return (rootState.user.uid === 'ZFvomQD71Bhf2ckUDSeRVNfkeEw2')
    },
    fonts: state => {
      return Object.keys(state.availableFonts)
    },
    fontsData: state => {
      return state.availableFonts
    }
  },
  mutations: {
    setActiveObject: (state, payload) => {
      state.activeObject = payload
    },
    setActiveFont: (state, payload) => {
      state.activeFont = payload
    },
    setActiveTemplate: (state, payload) => {
      state.activeTemplate = payload
    }
  },
  actions: {
    unbindAvailableFonts: firebaseAction(context => {
      if (Object.keys(context.state.availableFonts).length > 0) {
        context.unbindFirebaseRef('availableFonts')
      }
    }),
    getAvailableFonts: firebaseAction(context => {
      context.bindFirebaseRef('availableFonts', db.ref(environment.schema.availableFonts))
    }),
    unbindLibrary: firebaseAction(context => {
      if (context.state.templateLibrary.length > 0) {
        context.unbindFirebaseRef('templateLibrary')
      }
    }),
    getTemplateLibrary: firebaseAction(context => {
      context.bindFirebaseRef('templateLibrary', db.ref(environment.schema.templateLibrary))
    }),
    unbindUserTemplates: firebaseAction(context => {
      if (Object.keys(context.state.userTemplates).length > 0) {
        context.unbindFirebaseRef('userTemplates')
      }
    }),
    getUserTemplates: firebaseAction(context => {
      let ref = db.ref(environment.schema.userTemplates).child(context.rootState.user.groupId)
      // console.log('user template ref: ', ref.toString())
      // ref.once('value', snap => {
      //   console.log(JSON.stringify(snap.val(), null, 2))
      // })
      context.bindFirebaseRef('userTemplates', ref)
    }),
    deleteUserTemplate: (context, payload) => {
      return db.ref(environment.schema.userTemplates).child(context.rootState.user.groupId).child(payload).remove()
    },
    setActiveFont: (context, payload) => {
      context.commit('setActiveFont', payload)
    },
    setActiveObject: (context, payload) => {
      context.commit('setActiveObject', payload)
    },
    setActiveTemplate: (context, payload) => {
      context.commit('setActiveTemplate', payload)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/editor.js